import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Button,
  Col,
  Card,
} from "reactstrap"
import { Steps, Popconfirm, Tooltip, Form as AntdForm, Input as AntdInput } from "antd"
import { withTranslation } from "react-i18next"
const { TextArea } = AntdInput;


const SendSMSModal = props => {
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <Modal
      isOpen={props.sendSMSModal}
      toggle={() => props.setSendSMSModal(false)}
      centered
      style={{ maxWidth: "370px" }}
    >
      <ModalBody>
        <div className="p-2">
          <Form onSubmit={e => e.preventDefault()}>
            <Steps
              type="navigation"
              size="small"
              current={currentStep}
              className="pb-3 pt-0"
              items={[
                { key: "info", title: props.t("Enter information") },
                { key: "review", title: props.t("Review") },
              ]}
            />

            {currentStep === 0 && (
              <>
                <Col className="mt-2 mb-5">
                  <FormGroup>
                    <Label for="recipient">{props.t("Recipient")}</Label>
                    <AntdForm.Item validateStatus={props.smsValidation.errors.recipient ? "error" : ""} hasFeedback help={props.smsValidation.errors.recipient}>
                      <AntdInput
                        allowClear
                        placeholder={"+358401234567"}
                        value={props.smsValidation.values.recipient}
                        onChange={(v) => { props.smsValidation.setFieldValue("recipient", v.target.value) }}
                      />
                    </AntdForm.Item>
                  </FormGroup>
                  <FormGroup className="mt-2">
                    <Label for="message">{props.t("Message")}</Label>
                    <AntdForm.Item validateStatus={props.smsValidation.errors.message ? "error" : ""} hasFeedback help={props.smsValidation.errors.message}>
                      <TextArea
                        allowClear
                        showCount
                        maxLength={320}
                        rows={12}
                        placeholder={props.t("Enter message")}
                        value={props.smsValidation.values.message}
                        onChange={(v) => { props.smsValidation.setFieldValue("message", v.target.value) }}
                      />
                    </AntdForm.Item>
                  </FormGroup>
                </Col>
              </>
            )}

            {currentStep === 1 && (
              <>
                <Card className="shadow-none border p-3 mb-3 ">
                  <div className="text-muted mb-4 ">
                    <h6 className="d-inline">{props.t("Recipient")}: </h6>
                    {props.smsValidation.values.recipient}
                  </div>

                  <div className="text-muted mb-4">
                    <h6>{props.t("Message")}:</h6>
                    <div className="rounded p-2 mt-2 custom-preview-box">
                      {props.smsValidation.values.message}
                    </div>
                  </div>
                </Card>
              </>
            )}

            <div className="d-flex justify-content-between">
              <div>
                <Button
                  color="primary"
                  outline
                  onClick={() => props.setSendSMSModal(false)}
                >
                  {props.t("Cancel")}
                </Button>

                {currentStep === 0 && (
                  <Tooltip
                    title={props.t("Reset values")}
                    trigger={["hover", "focus"]}
                  >
                    <Popconfirm
                      title={props.t("Reset values")}
                      onConfirm={() => props.smsValidation.resetForm()}
                    >
                      <Button
                        className="ms-2"
                        color="primary"
                        outline
                        type="reset"
                      >
                        <i className="mdi mdi-refresh" />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                )}

                {currentStep === 1 && (
                  <Button
                    color="primary"
                    outline
                    style={{
                      margin: "0 8px",
                    }}
                    onClick={() => setCurrentStep(0)}
                  >
                    {props.t("Previous")}
                  </Button>
                )}
              </div>

              <div className="text-end">
                {currentStep === 0 && (
                  <Button
                    color="primary"
                    className="ms-2"
                    onClick={() => setCurrentStep(1)}
                    disabled={
                      !props.smsValidation.values.recipient ||
                      !props.smsValidation.values.message
                    }
                  >
                    {props.t("Next")}
                  </Button>
                )}

                {currentStep === 1 && (
                  <Popconfirm
                    title={
                      props.t("Send SMS to: ") +
                      props.smsValidation.values.recipient
                    }
                    onConfirm={props.smsValidation.handleSubmit}
                    okType="success"
                    okText={props.t("Send")}
                    cancelText={props.t("Cancel")}
                  >
                    <Button
                      color="success"
                      className="ms-2"
                      disabled={props.sending}
                    >
                      {props.t("Send")}
                    </Button>
                  </Popconfirm>
                )}
              </div>
            </div>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  )
}

SendSMSModal.propTypes = {
  t: PropTypes.func,
  sendSMSModal: PropTypes.bool,
  setSendSMSModal: PropTypes.func,
  smsValidation: PropTypes.any,
  sending: PropTypes.any,
}

export default withTranslation()(SendSMSModal)
